<div class="relative z-50 bg-dark" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div  [ngClass]="{
  'opacity-0 ease-out duration-300 hidden': !mediaStore.showMediaLib,
  'opacity-100 ease-in duration-200': mediaStore.showMediaLib
  }" class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" (click)="onClose()"></div>
    <div #modal class="fixed inset-0 z-10 w-screen m-auto overflow-y-auto" [ngClass]="{
'hidden': !mediaStore.showMediaLib
}">
        <div class="flex min-h-full items-end justify-center text-center sm:items-center">
            <div [ngClass]="{
  'opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95': !mediaStore.showMediaLib,
  'opacity-100 translate-y-0 sm:scale-100': mediaStore.showMediaLib
  }" class="relative transform overflow-hidden rounded-lg bg-dark text-left shadow-xl transition-all sm:my-8 w-[800px]">
                <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block text-normal">
                    <button type="button" (click)="onClose()" class="rounded-md bg-dark text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                        <span class="sr-only">Close</span>
                        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <section>
                    <div class="bg-card px-4 pb-4 pt-5  sm:p-6">
                        <div>
                            <h4 class="text-normal text-lg font-bold">{{ 'Media library'  | translate}}</h4>
                        </div>
                        <div class="sizes-block py-1 mb-2 h-28" *ngIf="mediaStore.showSizes">

                            <h4 class="text-normal text-sm">{{ 'Filter by size'  | translate}}</h4>
                            <div class="horizontal-scroll-wrapper-sizes flex justify-start gap-2">
                                <div *ngIf="!showCropperBlock"
                                        (click)="setAll()"
                                        [ngClass]="selectedSize === null ? 'active-item' : ''"
                                        class="item h-20 min-w-20 max-w-32 text-normal cursor-pointer text-sm">
                                    {{"All" | translate}}
                                </div>
                                <div *ngFor="let size of imageSizes"
                                     (click)="setSizeForFilter(size)"
                                     [ngClass]="selectedSize?.id == size.id ? 'active-item' : ''"
                                     class="item {{size.class}} max-h-20 min-w-20 max-w-32 text-normal cursor-pointer text-sm">
                                    {{size.title | translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="px-4 pb-4 pt-5  sm:p-6">
                        @if(mediaStore.showMediaLib && !showCropperBlock ){
                            <div class="block min-h-72">

                                <h4 class="text-normal text-sm py-2">{{ 'Choose file for continue'  | translate}}</h4>
                                <div class="grid grid-cols-4 gap-4 items-center">
                                    <a class="upload-card aspect-square flex items-center justify-center rounded-md text-normal cursor-pointer" (click)="openNewImage()"  (dragover)="onDragOver($event)"
                                       (dragleave)="onDragLeave($event)"
                                       (drop)="onDrop($event)"
                                       [class.dragover]="isDragging" >
                                        <div class="text-normal text-center"
                                        >
                                            <svg class="m-auto block" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                <line x1="12" y1="5" x2="12" y2="19"></line>
                                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                            </svg>
                                            {{'new_media' | translate}}
                                        </div>
                                    </a>

                                    <div *ngIf="mediaStore.uploadingProcess" class="module rounded-md transition-all duration-300 aspect-square relative">
                                        <div class="absolute top-0 left-0 w-full h-full bg-bg_primary bg-opacity-50 flex items-center justify-center">
                                            <div class="flex flex-col items-center space-y-2">
                                                <!-- Smaller Horizontal Progress Bar with Dynamic Color -->
                                                <div class="relative w-32 h-1 bg-gray-300 rounded-full overflow-hidden">
                                                    <!-- Animated progress bar with dynamic color based on progress -->
                                                    <div
                                                            class="absolute top-0 left-0 h-full"
                                                            [ngClass]="{
                                                                'bg-red-500': mediaStore.progressVideoUpload <= 30,
                                                                'bg-yellow-500': mediaStore.progressVideoUpload > 30 && mediaStore.progressVideoUpload <= 70,
                                                                'bg-green': mediaStore.progressVideoUpload > 70
                                                            }"
                                                            [style.width]="mediaStore.progressVideoUpload + '%'"
                                                            style="transition: width 0.5s ease-out;">
                                                    </div>
                                                </div>

                                                <!-- Progress Percentage -->
                                                <span class="text-normal text-sm font-semibold">{{ mediaStore.progressVideoUpload | number: '1.0-0' }}%</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div  *ngFor="let item of  imagesList "
                                          class="module  rounded-md transition-all duration-300 aspect-square"
                                          [ngClass]="selectedItemsIndexArr.includes(item.id) ? 'selected-img': ''"
                                          (click)="selectItem(item.id,item)"
                                          (dblclick)="doubleClickItem($event,item)"
                                    >
                                        <img loading="lazy" *ngIf="item.type === 'image'"  src="{{item.s3Url}}"  class="object-contain bg-gray-800 w-full h-full rounded-md" alt="">
                                        <div class="relative cursor-pointer">
                                            <div class="absolute w-full h-full top-0 left-0 z-10"></div>
                                            <video *ngIf="item.type === 'video'"
                                                   [src]="item.s3Url" controls class="object-contain bg-gray-800 w-full h-full rounded-md" loading="lazy" (dblclick)="$event.preventDefault(); $event.stopPropagation()"></video>
                                        </div>


                                    </div>
                                </div>
                                <div class="show-more text-white text-center m-auto p-3 bg-primary mt-2" *ngIf="next"> <button (click)="loadMore()">{{'load_more' | translate}}</button> </div>
                            </div>
                        }

                        <div class="cropper-block">
                            <app-file-uploader #cropper
                                               [settings]="selectedSize?.cropperSettings"
                                               [cropperSize]="selectedSize?.class"
                                               (showCropperBlock)="showCropperBlockFunc($event)"
                                               (imageSrc)="getImageSource($event)"
                                               (setVideoSource)="getVideoSource($event)"
                                               [formats] = "formats"
                            >
                            </app-file-uploader>
                        </div>
                        <app-mask-loader-private *ngIf="showLoader"></app-mask-loader-private>
                        <div class="app-modal-footer" [ngClass]="showCropperBlock ? 'hidden':''">
                            <app-secondary-button className="small" text="{{'close' | translate}}" (onClick)="onClose()"></app-secondary-button>
                            <app-primary-button className="ml-1 small" (click)="onSetImages()"  text="{{'save' | translate}}"></app-primary-button>
                        </div>
                    </div>

                </section>
            </div>
        </div>
    </div>
</div>

